import { render, staticRenderFns } from "./BatchSampleFilter.vue?vue&type=template&id=6b97712a&scoped=true"
import script from "./BatchSampleFilter.vue?vue&type=script&lang=js"
export * from "./BatchSampleFilter.vue?vue&type=script&lang=js"
import style0 from "./BatchSampleFilter.vue?vue&type=style&index=0&id=6b97712a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b97712a",
  null
  
)

export default component.exports